export default {
    namespaced: true,
    state: {
        list: [],
        total: 0,
        perPage: 0,
        loading: false,
        error: false,
        userUrl: "/profile/accounts/withdraw",
        adminUrl: "/admin/accounts",
        adminWithdrawUrl: "/admin/withdraw",
    },
    mutations: {
        setList: (state, data) => (state.list = [...data]),
        setTotal: (state, total) => (state.total = total),
        setPerPage: (state, perPage) => (state.perPage = perPage),
        setError: (state, error) => (state.error = error),
        setSuccess: (state, success) => (state.success = success),
        removeError: state => (state.error = false),
        loadingProcess: state => (state.loading = true),
        loadingCompleted: state => (state.loading = false),
        getOfdData: (state, payload) => (state.ofdFormData = payload)
    },
    actions: {
        async create({state, commit}, payload) {
            commit("loadingProcess")
            commit("removeError")
            let data
            try {
                data = await axios.post(state.userUrl, payload)
            } catch (error) {
                console.error(error)
                commit("setError", error.message)
            }
            commit("loadingCompleted")
            return data
        },
        async adminFetchUserWithdraws({state, commit}, payload) {
            commit("loadingProcess")
            commit("setList", [])
            commit("removeError")
            try {
                const {data} = await axios.get(`${state.adminUrl}/${payload.user}/withdraw?page=${payload.page}`)
                commit("setList", data.data)
                commit("setTotal", data.total)
                commit("setPerPage", data.per_page)
            } catch (error) {
                console.error(error)
                commit("setError", error.message)
            }
            commit("loadingCompleted")
        },
        async adminFetchWithdraws({state, commit}, payload) {
            commit("loadingProcess")
            commit("setList", [])
            commit("removeError")
            try {
                const {data} = await axios.get(`${state.adminWithdrawUrl}?page=${payload.page}`)
                commit("setList", data.data)
                commit("setTotal", data.total)
                commit("setPerPage", data.per_page)
            } catch (error) {
                console.error(error)
                commit("setError", error.message)
            }
            commit("loadingCompleted")
        },
        async adminFetchWithdrawsCount({state, commit}) {
            commit("loadingProcess")
            commit("removeError")
            try {
                const {data} = await axios.get(`${state.adminWithdrawUrl}/count`)
                commit("setTotal", data.data)
            } catch (error) {
                console.error(error)
                commit("setError", error.message)
            }
            commit("loadingCompleted")

        },
        async changeStatus({commit, state}, payload) {
            commit("loadingProcess")
            commit("removeError")
            try {
                await axios.put(`${state.adminWithdrawUrl}/${payload.id}`, {'status': payload.status, 'isRefillDebt': payload.isRefillDebt})
            } catch (error) {
                console.error(error)
                commit("setError", error.message)
            }
            commit("loadingCompleted")
        },
        async deleteStatus({commit, state}, payload) {
            commit("loadingProcess")
            commit("removeError")
            try {
                await axios.post(`${state.adminWithdrawUrl}/delete/${payload.id}`, {'status': payload.status})
            } catch (error) {
                console.error(error)
                commit("setError", error.message)
            }
            commit("loadingCompleted")
        },
    },
};
